import TalentPoolEngineers from "../../views/TalentPoolEngineers";

const TalentPoolEngineersPage = () => {
  return <TalentPoolEngineers />;
};

export default TalentPoolEngineersPage;
